import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c3f5c29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "navbar-holder" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, "r2business.app", -1))
const _hoisted_4 = { class: "menu-mobile" }
const _hoisted_5 = { class: "menu-desktop" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: {name: 'Home'} }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode($setup["DashboardNavBarMobile"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode($setup["DashboardNavbarDesktop"])
        ])
      ])
    ])
  ]))
}